<script>
    import AssessmentDashboard from './Sections/AssessmentDashboard.svelte';
    import AssessmentForm from './Sections/AssessmentForm.svelte';
    import FindingsReview from './FindingsReview.svelte';
    import AssessmentLibrary from './Sections/AssessmentLibrary.svelte';
    import AssessmentPolicies from './Sections/AssessmentPolicies.svelte';
    import AssessmentScores from './Sections/AssessmentScores.svelte';

    import {clean} from '../../Utilities/Cleaner.svelte';

    import Popup from '../Popup.svelte';
    import ReportComments from './ReportComments.svelte';

    export let assessment;
    export let assessment_model;
    export let section_id;

    $: section = $assessment.assessment_type_data.report_sections.filter((sec) => sec.section_id == section_id)[0]

    let showComments = false;

    let components = {
        'dashboard': AssessmentDashboard,
        'form': AssessmentForm,
        'findings': FindingsReview,
        'library': AssessmentLibrary,
        'policies': AssessmentPolicies,
        'scores': AssessmentScores
    }
</script>

<h1 class="title is-1">{section.section_name}</h1>

{#key section_id}
    {#if components[section.section_type]}
        {#if section.section_description}
            <div>
                {@html clean(section.section_description)}
            </div>
        {/if}
        <svelte:component this={components[section.section_type]} {assessment} {assessment_model} {section}></svelte:component>
    {:else}
        <h1 class="title is-1">Unrecognized Section Type</h1>
    {/if}
{/key}

<Popup title="Peer Review Comments" bind:visible={showComments} id="peer_comments">
    <div class="comments">
        <ReportComments {assessment} {assessment_model}></ReportComments>
    </div>
</Popup>

<button class="button" class:is-primary={showComments} class:is-hidden={showComments} id="chat-button" on:click={() => showComments = true}>
    &#128489;
</button>

<style>
    .comments {
        display: grid;
        height: 100%;
        grid-template-rows: min-content auto min-content;
        padding: 1em;
    }

    #chat-button {
        position: fixed;
        top: 50px;
        right: 50px;
        border-radius: 500px;
        width: 50px;
        height: 50px;
        text-align: center;
        line-height: 50px;
        padding: 0;
        margin: 0;
        cursor: pointer;
    }
</style>